<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{
          facilityType.title("ＱＲコード登録")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <v-row dense>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field v-model="group_name" label="発行単位" disabled>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="10">
            <v-file-input
              v-model="input_file"
              accept=".csv"
              :placeholder="config.PLACEHOLDER_FILE"
              prepend-icon="mdi-paperclip"
              outlined
              @change="fileUpload"
            >
              <template v-slot:selection="{ text }">
                <v-chip small label color="primary">{{ text }}</v-chip>
              </template>
            </v-file-input>
          </v-col>
        </v-row>
        <v-divider class="mb-1"></v-divider>
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>ファイルデータ</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-if="items.length > 0">
          <top-operation-data-table
            :headers="headers"
            :items="items"
            :sort-by="['no']"
            :sortDesc="false"
            locale="ja-jp"
            loading-text="読込中"
            no-data-text="データがありません。"
            must-sort
            class="fixedWidth"
            disp-mode="nowrap"
          >
            <template v-slot:[`item.sch_year`]="{ item }">
              {{ item.sch_year }}年
            </template>
            <template v-slot:[`item.year`]="{ item }">
              {{ item.year }}年
            </template>
            <template v-slot:[`item.att_num`]="{ item }">
              {{ ("000" + item.att_num).slice(-3) }}
            </template>
            <template v-slot:[`item.sch_cls`]="{ item }">
              {{ item.sch_cls }}組
            </template>
            <template v-slot:[`item.name_kanji`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="text-truncate d-inline-block"
                    style="max-width: 720px"
                  >
                    {{ item.name_kanji }}
                  </span>
                </template>
                <span> {{ item.name_kanji }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.name_kana`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="text-truncate d-inline-block"
                    style="max-width: 720px"
                  >
                    {{ item.name_kana }}
                  </span>
                </template>
                <span> {{ item.name_kana }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.address`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="text-truncate d-inline-block"
                    style="max-width: 720px"
                  >
                    {{ item.address }}
                  </span>
                </template>
                <span> {{ item.address }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.remarks`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="text-truncate d-inline-block"
                    style="max-width: 720px"
                  >
                    {{ item.remarks }}
                  </span>
                </template>
                <span> {{ item.remarks }}</span>
              </v-tooltip>
            </template>
          </top-operation-data-table>
          <v-row>
            <v-col>
              <v-btn class="mx-2" color="primary" @click="register"
                >QRコード登録</v-btn
              >
            </v-col>
          </v-row>
        </template>
        <v-row>
          <v-col>
            <v-btn class="mx-2" color="primary" @click="close">戻る</v-btn>
          </v-col>
        </v-row>
        <ErrorDialog ref="errorDialog" />
      </v-container>
    </v-sheet>
    <v-overlay :value="overlay" opacity="1" color="white" z-index="2147483647">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import ErrorDialog from "@/components/ErrorDialog";
import QrCodeFacilityType from "@/plugins/qr-code-facility-type";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import messageUtils from "@/mixins/message-utils";
import { ErrorTodoMessages } from "@/js/constants/error-messages";
import config from "@/js/const";
Vue.use(QrCodeFacilityType);
const vulFacilityEvagrpRepository = RepositoryFactory.get("vulFacilityEvagrp");
const considerationPersonUploadRepository = RepositoryFactory.get(
  "considerationPersonUpload"
);
const studentUploadRepository = RepositoryFactory.get("studentUpload");
const UUID = require("uuidjs");

export default {
  mixins: [messageUtils],
  components: {
    ErrorDialog,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },
  data: () => ({
    loading: false,
    overlay: false,
    type: "",
    group_id: "",
    group_name: "",
    fa_name: "",
    address: "",
    birthday: "",
    sex: "",
    iodine_hold: "",
    pregnancy: "",
    care_reason: "",
    year: "",
    file_group_name: "",
    file_fa_name: "",
    file_year: "",
    headers: [],
    items: [],
    config: config, // 共通プレースホルダ
    input_file: null // ファイルインプットフォームのv-model
  }),

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.facilityType = this.$facilityType.factory(
        this.$route.name === "school-qr-code-register"
      );
      this.type = this.$route.query.type;
      this.group_id = this.$route.query.group_id;

      let screenId = ""; // ルートにある画面ID
      let screenName = ""; // ルートにある画面名
      // 画面によって画面のヘッダーとルート情報を初期化
      if (this.type === "SC") {
        screenId = "SF0605";
        screenName = "school-qr-code-group";
        this.headers = this.headerSchool();
      } else {
        screenId = "SF0602";
        screenName = "facility-qr-code-group";
        this.headers = this.headerFacility();
      }

      // 画面のブラウザタブー名設定
      this.pageTitle(this.facilityType.title("ＱＲコード登録"));

      await vulFacilityEvagrpRepository
        .getFacilityEvaGrpList(screenId)
        .then(response => {
          const targetFacilityEvaInfo = response.data.results.find(
            ele => ele.manage_grp_id === this.group_id
          );
          this.group_name = targetFacilityEvaInfo.manage_grp_name;
          this.fa_name = targetFacilityEvaInfo.fa_name;
          this.year = targetFacilityEvaInfo.year;
        })
        .catch(e => {
          this.handleError(e, screenId, screenName);
        });
    },

    async fileUpload(file) {
      // ファイル未選択か
      if (!file) {
        this.items = [];
        this.input_file = null; // ファイルインプットフォームの初期化
        return;
      }

      // .csvを選択したか(ファイル形式チェック)
      if (!file.name.toUpperCase().match(/\.(CSV)$/i)) {
        this.items = [];
        // エラーダイアログの表示
        await this.$refs.errorDialog.open(ErrorTodoMessages.ERWE40010);
        this.input_file = null;
        return;
      }

      if (this.type === "SC") {
        this.headers = this.headerSchool();
        const fr = new FileReader();
        fr.readAsText(file);
        fr.addEventListener("load", () => {
          this.item = [];
          this.convertCSVtoScItem(fr.result);
        });
      } else {
        this.headers = this.headerFacility();
        // ファイル読み込み～テーブルへの変換処理
        const fr = new FileReader();
        fr.readAsText(file);
        fr.addEventListener("load", () => {
          this.item = [];
          this.convertCSVtoFaItem(fr.result);
        });
      }
    },

    headerSchool() {
      return [
        {
          text: "No",
          value: "qrdisp_id"
        },
        {
          text: "年度",
          value: "year"
        },
        {
          text: "学校名",
          value: "fa_name"
        },
        {
          text: "学年",
          value: "sch_year"
        },
        {
          text: "組",
          value: "sch_cls"
        },
        {
          text: "出席番号",
          value: "att_num"
        },
        {
          text: "氏名",
          value: "name_kanji"
        },
        {
          text: "氏名カナ",
          value: "name_kana"
        },
        {
          text: "備考",
          value: "remarks"
        }
      ];
    },

    headerFacility() {
      return [
        {
          text: "No",
          value: "no"
        },
        {
          text: "施設名",
          value: "fa_name"
        },
        {
          text: "氏名",
          value: "name_kanji"
        },
        {
          text: "氏名カナ",
          value: "name_kana"
        },
        {
          text: "現住所",
          value: "address"
        },
        {
          text: "生年月日",
          value: "birthday"
        },
        {
          text: "性別",
          value: "sex",
          align: "center"
        },
        {
          text: "安定ヨウ素剤所持状況",
          value: "iodine_hold",
          align: "center"
        },
        {
          text: "妊娠有無",
          value: "pregnancy",
          align: "center"
        },
        {
          text: "要配慮の理由",
          value: "care_reason"
        },
        {
          text: "備考",
          value: "remarks"
        }
      ];
    },

    formatDate(date) {
      const formattedDate = this.$moment(date);
      if (formattedDate.isValid()) {
        return formattedDate.format("YYYY/MM/DD");
      }
      return "";
    },

    async register() {
      // 読み込みGUI表示
      this.overlay = true;

      if (this.type === "SC") {
        let studentList = [];
        this.items.forEach(i => {
          studentList.push({
            student_id: UUID.generate(),
            manage_grp_id: this.group_id,
            qrdisp_id: i.qrdisp_id,
            fa_name: this.file_fa_name,
            year: this.file_year,
            sch_year: i.sch_year,
            sch_cls: i.sch_cls,
            att_num: i.att_num,
            name_kanji: i.name_kanji,
            name_kana: i.name_kana,
            remarks: i.remarks
          });
        });
        this.clearMessage();
        await studentUploadRepository
          .registerStudents(studentList, "SF0605")
          .then(response => {
            this.handleSuccess(response, "school-qr-code-group");
            // this.$router.push({
            //   path: this.facilityType.groupPath()
            // });
          })
          .catch(e => {
            this.handleError(e, "SF0605", "school-qr-code-group");
          });
      } else {
        let personList = [];
        this.items.forEach(i => {
          personList.push({
            cns_person_id: UUID.generate(),
            manage_grp_id: this.group_id,
            qrdisp_id: i.no,
            fa_name: this.file_fa_name,
            year: this.file_year,
            name_kanji: i.name_kanji,
            name_kana: i.name_kana,
            address: i.address,
            birthday: this.convBirthday(i.birthday),
            sex: this.convSex(i.sex),
            iodine_possession: this.convEysNone(i.iodine_hold),
            pregrancy_possibility: this.convEysNone(i.pregnancy),
            required_consideration: i.care_reason,
            remarks: i.remarks,
            qrcode_class: this.type
          });
        });
        this.clearMessage();
        await considerationPersonUploadRepository
          .registerConsiderationPerson(personList, "SF0602")
          .then(response => {
            this.handleSuccess(response, "facility-qr-code-group");
            // this.$router.push({
            //   path: this.facilityType.groupPath()
            // });
          })
          .catch(e => {
            this.handleError(e, "SF0602", "facility-qr-code-group");
          });
      }
    },

    /* 登録時のデータ変換 */
    //生年月日
    convBirthday(value) {
      if (value == "") {
        return "";
      } else {
        return this.$moment(value, "YYYY/MM/DD").format("YYYYMMDD");
      }
    },

    //性別
    convSex(value) {
      if (value == "男") {
        return "1";
      } else if (value == "女") {
        return "2";
      } else if (value == "どちらでもない") {
        return "3";
      }
    },

    //有無判定
    convEysNone(value) {
      if (value == "無") {
        return "0";
      } else {
        return "1";
      }
    },

    close() {
      this.$router.push({
        path: this.facilityType.groupPath()
      });
    },

    async convertCSVtoFaItem(str) {
      this.items = [];

      // 配列に変換
      const csvArray = this.convertCSVtoArray(str);

      // エラーチェック
      // 配列の数確認
      for (let [index, e] of csvArray.entries()) {
        if (
          (index === 0 && e.length !== 3) ||
          (index !== 0 && e.length !== 10 && !(e.length === 1 && !e[0]))
        ) {
          // エラーダイアログの表示(読み込み失敗)
          await this.$refs.errorDialog.open(ErrorTodoMessages.ERWE40007);
          this.input_file = null;
          return;
        }
      }
      // 発行単位名エラー
      if (!(csvArray[0][1] === this.group_name)) {
        // エラーダイアログの表示
        await this.$refs.errorDialog.open(
          ErrorTodoMessages.ERWE40011(this.group_name, csvArray[0][1])
        );
        this.input_file = null;
        return;
      }
      // 施設名エラー
      if (!(csvArray[0][2] === this.fa_name)) {
        // エラーダイアログの表示
        await this.$refs.errorDialog.open(
          ErrorTodoMessages.ERWE40013(this.fa_name, csvArray[0][2])
        );
        this.input_file = null;
        return;
      }

      csvArray.forEach((ele, i) => {
        if (i === 0) {
          this.file_group_name = ele[1];
          this.file_fa_name = ele[2];
        }

        if (i < 2) {
          return;
        }

        this.items.push({
          no: ele[0],
          fa_name: this.file_fa_name,
          name_kanji: ele[1],
          name_kana: ele[2],
          address: ele[3],
          birthday: this.formatBirthDay(ele[4]),
          sex: ele[5],
          iodine_hold: ele[6],
          pregnancy: ele[7],
          care_reason: ele[8],
          remarks: ele[9]
        });
      });
    },

    /**
     * データテーブル表示用（生年月日）
     */
    formatBirthDay(date) {
      const formattedDate = this.$moment(date);
      if (formattedDate.isValid()) {
        return formattedDate.format("YYYY年MM月DD日");
      }
      return "";
    },

    async convertCSVtoScItem(str) {
      this.items = [];

      // 配列に変換
      const csvArray = this.convertCSVtoArray(str);

      // エラーチェック
      // 配列の数確認
      for (let [index, e] of csvArray.entries()) {
        if (
          (index === 0 && e.length !== 4) ||
          (index !== 0 && e.length !== 7 && !(e.length === 1 && !e[0]))
        ) {
          // エラーダイアログの表示
          await this.$refs.errorDialog.open(ErrorTodoMessages.ERWE40007);
          this.input_file = null;
          return;
        }
      }
      // 発行単位名エラー
      if (!(csvArray[0][1] === this.group_name)) {
        // エラーダイアログの表示
        await this.$refs.errorDialog.open(
          ErrorTodoMessages.ERWE40011(this.group_name, csvArray[0][1])
        );
        this.input_file = null;
        return;
      }
      // 年度に関する仕様が固まっていないので、エラーチェックを一時的に外している
      // 年度エラー
      if (!(csvArray[0][2] == this.year)) {
        // エラーダイアログの表示
        await this.$refs.errorDialog.open(
          ErrorTodoMessages.ERWE40014(this.year, csvArray[0][2])
        );
        this.input_file = null;
        return;
      }
      // 施設名エラー
      if (!(csvArray[0][3] === this.fa_name)) {
        // エラーダイアログの表示
        await this.$refs.errorDialog.open(
          ErrorTodoMessages.ERWE40013(this.fa_name, csvArray[0][3])
        );
        this.input_file = null;
        return;
      }

      csvArray.forEach((ele, i) => {
        if (i === 0) {
          this.file_group_name = ele[1];
          this.file_year = ele[2];
          this.file_fa_name = ele[3];
        }

        if (i < 2) {
          return;
        }

        this.items.push({
          qrdisp_id: ele[0],
          year: this.file_year,
          fa_name: this.file_fa_name,
          sch_year: ele[1],
          sch_cls: ele[2],
          att_num: ele[3],
          name_kanji: ele[4],
          name_kana: ele[5],
          remarks: ele[6]
        });
      });
    },

    // 読み込んだCSVデータを二次元配列に変換する
    convertCSVtoArray(str) {
      let result = [];
      const tmp = str.split("\n");

      // 各行ごとにカンマで区切った文字列を要素とした二次元配列を生成
      for (let i = 0; i < tmp.length; ++i) {
        result[i] = tmp[i].split(",");
        // \rの削除
        result[i][result[i].length - 1] = result[i][
          result[i].length - 1
        ].replace(/\r?\n?/g, "");
      }
      // 末尾が空行の場合、削除する
      if (result[tmp.length - 1].length === 1) {
        result.pop();
      }
      return result;
    }
  }
};
</script>
